module.exports = __webpack_public_path__ + "img/giftcard.31f5ac29.svg";